import { SupportType } from '@/types/support.type';

export const supportDummy: SupportType = {
  title: '도로로 서비스 소개',
  subtitle:
    '운전의 시작부터 자신감까지\n' + '데이터 기반 맞춤형 운전코칭 서비스',
  discription1:
    '당사는 운전면허 취득을 준비하는 초보 운전부터 장롱면허 등 모두를 위한 스마트 운전 연습 플랫폼을 운영하고 있습니다.\n\n' +
    '전국 23개 운전면허시험장의 장내기능 및 도로주행 코스를 시뮬레이터로 구현하여, 실제시험 환경과 동일한 조건에서 연습이 가능합니다.\n\n' +
    '시뮬레이터 주행 데이터를 기반으로 급가속, 급제동, 차간거리 유지, 반응속도 등 다양한 항목을 분석하여 맞춤형 피드백과 코칭을 제공합니다.\n\n' +
    '안전한 연습이 성취감과 자신감 있는 운전으로 이어질 수 있게 당사가 함께하겠습니다.\n\n',
  discription2: '(만 18세 이상 이용 가능)',
  callNumber: '1522-7730',
  email: 'manager@adrock.me',
};
